app.service("ProductCurvedService", ['$rootScope', 'ProductService', function ($rootScope, ProductService) {

    const siteHelper = $rootScope.site_helper;
    const modelConstructor = $rootScope.model_constructor;

    const ProductCurvedModel = modelConstructor.extend(ProductService.BasicProductModel, {
        id: "product_curved",
        base_component_id: "curved",
        request_range_id: "bella",
        is_single_item_model: true,
        dataResponseHandler: dataResponseHandler,
        applyItemHandler: applyItemHandler
    });

    this.factory = new ProductService.BasicProductModelFactory({
        birth: function (values) {
            return new ProductCurvedModel(values);
        },

        validVariationPointers: function (variationIDs) {
            return ['browse_id', 'parent_category_id', 'site_range_id', 'style_id'];
        }
    });


    function applyItemHandler(product) {
        this.super(product);

        const parentCategoryID = product.parent_category_id;
        const componentObject = $rootScope.service.cache_local_server.getComponentObject(product.base_component_id, product.parent_category_group_id, product.parent_category_id);
        if (componentObject) {
            if (componentObject.name) {
                product.originalName = product.name;
                product.name = componentObject.name;
            }
            if (!product.img_src) {
                product.img_src = componentObject.img_src;
            }
        }

        product.quantity = 1;
        product.applynonstdsurcharge = false;
        product.left_side_square = false;
        product.right_side_square = false;
        product.rotate_grain = false;
        product.drillside = '';
        product.drill_0 = '';
        product.drill_1 = '';
        product.drill_2 = '';
        product.drill_3 = '';
        product.drill_4 = false;
        product.drill_5 = false;
        product.hinge_hole_options = $rootScope.service.product.getHingeHoleOptions(product, "-- None --");
        product.group_name = product.name;

        siteHelper.applyValues(product, {
            finalPrice: function () {
                return finalPrice(product);
            }
        });

        const detail = {
            name: "",
            body: [],
            note: ""
        }

        product.allow_zero_value = true;
        switch (parentCategoryID) {
            case "curved_door_715mm":
                detail.name = "Dimensions";
                detail.body = [
                    "715mm x 298mm x 298mm (wall/base door)",
                    "Curved Doors are supplied in slab style with a 3mm radius edge. Back colour is silver."];
                detail.note = "Image shows 715x298x298 curved door";
                break;
            case "curved_door_shaker_715mm":
                detail.body = [product.description];
                break;
            case "curved_accessory_plinth_150mm":
                detail.name = "Dimensions";
                detail.body = [
                    "150mm x 250mm x 250mm H",
                    "Plinth is set back 50mm from the door."];
                break;
            case "curved_accessory_rail_multi_purpose":
                detail.name = "Dimensions";
                detail.body = [
                    "320mm x 320mm x 36mm",
                    "For use as cornice and pelmet to match curved doors.",
                    "Fits flush with door face."];
                break;
            case "curved_accessory_components_for_curved_door_cabinet_720mm":
                detail.body = [
                    "Components are vinyl wrapped in Bella colours. Self-Assembly required. When finished you will have " +
                    "a Cabinet 720mm x 300mm x 300mm with 2 shelves. Legs not included. Only for use with Bella Curved Doors"];
                break;
            default:
                break;
        }

        product.detail = detail;
    }

    function dataResponseHandler(data) {
        const model = this.root;
        return data.products ? data.products[model.api_code] : null;
    }

    function finalPrice(product) {
        return $rootScope.service.product.appliedMinimumDiscountPrice(product, product.base_price);
    }
}])